// src/pages/Transactions/TransactionStates.jsx
import React from 'react';
import { transactionStyles } from './styles';

// SVG Icons
const SpinnerIcon = () => (
  <svg 
    width="48" 
    height="48" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2"
    style={transactionStyles.spinnerAnimation}
  >
    <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83" />
  </svg>
);

const EmptyBoxIcon = () => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

const ShoppingBagIcon = () => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <path d="M16 10a4 4 0 0 1-8 0" />
  </svg>
);

const DollarIcon = () => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

const LockIcon = () => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export const LoadingState = () => (
  <div style={transactionStyles.loadingContainer}>
    <SpinnerIcon />
    <h3 style={transactionStyles.loadingTitle}>Loading your orders...</h3>
    <p style={transactionStyles.loadingText}>Please wait while we fetch your order history.</p>
  </div>
);

export const EmptyState = ({ filter }) => {
  const getEmptyMessage = () => {
    switch(filter) {
      case 'purchases':
        return {
          icon: <ShoppingBagIcon />,
          title: 'No Purchases Yet',
          message: 'You haven\'t made any purchases on Redbird Markets yet. Browse the marketplace to find great deals!'
        };
      case 'sales':
        return {
          icon: <DollarIcon />,
          title: 'No Sales Yet', 
          message: 'You haven\'t sold anything yet. List your items to start earning money!'
        };
      default:
        return {
          icon: <EmptyBoxIcon />,
          title: 'No Orders Found',
          message: 'You haven\'t made any transactions yet. Start buying or selling on Redbird Markets!'
        };
    }
  };

  const { icon, title, message } = getEmptyMessage();

  return (
    <div style={transactionStyles.emptyState}>
      <div style={transactionStyles.emptyIcon}>{icon}</div>
      <h3 style={transactionStyles.emptyTitle}>{title}</h3>
      <p style={transactionStyles.emptyMessage}>{message}</p>
    </div>
  );
};

export const NoUserState = () => (
  <div style={transactionStyles.pageContainer}>
    <div style={transactionStyles.noUserContainer}>
      <div style={transactionStyles.noUserIcon}>
        <LockIcon />
      </div>
      <h2 style={transactionStyles.noUserTitle}>Please log in to view your orders</h2>
      <p style={transactionStyles.noUserMessage}>
        You need to be logged in to access your order history
      </p>
    </div>
  </div>
);